export default __webpack_public_path__ + "static/media/frmo-modal.a80e4a6c.jpg";